export default __webpack_public_path__ + "static/media/greenAvatar.6abda2a9.svg";